module.exports = __webpack_public_path__ + "static/logo-circle-3036a4662a2a7a716d602e31a528f0f3.svg";